import { identityScript, viewDocument } from "./document.js";

// `review_order`: the order's exact content at the revision to sign. Sign calls `sign_order` (sensitive: Talkie asks
// again). A stale revision is never retried: the view re-reads the order and the clinician signs again.
const body = `<div id="root"><p class="muted">Loading the order…</p></div>`;
const script = `${identityScript}
var root = document.getElementById("root"), state = null, requestId = null, done = false;
function row(label, value) { return value ? '<tr><th>' + label + '</th><td>' + view.esc(value) + '</td></tr>' : ''; }
/** The order as the clinician reviews it: what a re-read compares. */
function orderHtml(p) {
  var o = p.order;
  return '<h2>' + view.esc(o.type) + '</h2><table><tbody>' + row("Order", o.name) + row("Diagnosis", o.diagnosis) + row("Strength", o.strength) +
    row("Directions", o.directions) + row("Quantity", o.quantity) + row("Refills", o.refills) + row("Pharmacy", o.pharmacy) +
    row("Priority", o.priority) + row("Timing", o.timing) + row("Notes", o.notes) + row("Status", o.status) + '</tbody></table>';
}
function render() {
  var p = state, o = p.order, signed = o.status !== "Draft";
  var html = identityHtml(p.patient, { id: p.encounter_id, revision: p.revision, signed: false }, "Order " + o.id);
  html += orderHtml(p);
  html += '<p class="muted">Signing is simulated; nothing real is sent.</p>';
  html += '<div class="actions"><button id="sign" class="primary"' + (signed || done ? ' disabled' : '') + '>Sign order</button></div>';
  root.innerHTML = html;
  document.getElementById("sign").onclick = sign;
  view.reportSize();
}
function sign() {
  requestId = requestId || view.requestId();
  document.getElementById("sign").disabled = true;
  view.callTool("sign_order", {
    patient_id: state.patient_id, encounter_id: state.encounter_id, expected_revision: state.revision,
    request_id: requestId, order_id: state.order.id
  }).then(function (r) {
    if (!r.ok) {
      if (r.code !== "stale_revision") { document.getElementById("sign").disabled = false; showStatus(root, explain(r), true); return; }
      var before = state;
      done = true; requestId = null; render();
      afterStale(root, "sign", before, function () {
        return read("get_encounter", { patient_id: before.patient_id, encounter_id: before.encounter_id }).then(function (d) {
          var e = d.encounter, o = e.orders.filter(function (x) { return x.id === before.order.id; })[0];
          if (!o) throw new Error("The order is no longer on this encounter.");
          return { revision: e.revision, signed: e.signed, state: { patient: before.patient, patient_id: before.patient_id, encounter_id: e.id, revision: e.revision, order: o } };
        });
      }, orderHtml, function (fresh) { state = fresh; done = false; render(); });
      return;
    }
    done = true; state.revision = r.data.revision; if (r.data.order) state.order = r.data.order;
    render();
    showStatus(root, "Signed (simulated). The encounter is now revision " + r.data.revision + ".");
  });
}
view.onResult(function (data) {
  if (!data || !data.order) { root.textContent = "No order to show."; return; }
  state = data; requestId = null; done = false; render();
});
`;
export const orderView = viewDocument("Review order", body, script);
